<template>
  <div class="modal" :class="{ 'is-active': isActive }">
    <div class="modal-background"></div>
    <div class="modal-content">
      <div class="card">
        <header class="card-header">
          <p class="card-header-title">Document bewerken</p>
        </header>

        <div class="card-content">
          <form>
            <div class="field">
              <label for="name" class="label">Titel</label>
              <div class="control">
                <input name="name" type="text" class="input" v-model="doc.name">
              </div>
            </div>

            <div class="field">
              <label for="name" class="label">Omschrijving</label>
              <div class="control">
                <textarea class="textarea" v-model="doc.description"></textarea>
              </div>
            </div>

            <div class="field">
              <label for="name" class="label">Documenten, links, etc</label>
              <div class="control">
                <input class="input" type="text" name="documents" v-model="doc.documents">
              </div>
            </div>
          </form>
        </div>

        <footer class="card-footer">
          <a
            class="button is-text card-footer-item"
            @click="save"
            :class="{ 'is-loading': loading }">
            Opslaan
          </a>
        </footer>

      </div>
    </div>
    <button class="modal-close is-large" aria-label="close" @click="close"></button>
  </div>
</template>

<script>
  import axios from 'axios'
  import { bus } from '@/main'

  export default {
    props: ['itemId'],
    data () {
      return {
        loading: false,
        errors: [],
        doc: {},
        isActive: false
      }
    },
    created () {
      let self = this

      bus.$on('editDoc', function (payload) {
        self.doc = {}
        self.isActive = true

        if (payload.id)
          self.fetchDoc(payload.id)
      })
    },
    methods: {
      fetchDoc (id) {
        this.loading = true
        axios
          .get(`/documents/${id}`)
          .then(response => {
            this.doc = response.data
            this.loading = false
          })
          .catch(error => {
            console.log(error)
          })
      },
      close () {
        this.isActive = false
      },
      save () {
        this.loading = true
        this.doc.itemId = this.itemId

        if (this.doc.id) {
          axios
            .put(`/documents/${this.doc.id}`, this.doc)
            .then(response => {
              bus.$emit('documentEdited', this.doc)
              this.loading = false
              this.isActive = false
            })
            .catch(error => {
              this.loading = false
              console.log(error)
            })
        } else {
          axios
            .post(`/documents`, this.doc)
            .then(response => {
              bus.$emit('documentStored', response.data)
              this.loading = false
              this.isActive = false
            })
            .catch(error => {
              this.loading = false
              console.log(error)
            })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/documents/DocumentEdit.vue